import { cacheDecorator } from '@ds/swymkit/tools'

import type { ITenantOptions } from '~/features-shared/config-manager/interfaces/swym-options'

import type { SwymResponse } from '~/interfaces/services-dto'

export function getOptions() {
  return cacheDecorator(
    'tenant-options',
    () => import('~/services/fetch-swym')
      .then(({ swymFetch }) => {
        return swymFetch
          .get('/api/index/options')
          .json<SwymResponse<{ options: ITenantOptions }>>()
      }),
    10 * 60 * 1000, // 10mn cache
  )
}
